// extracted by mini-css-extract-plugin
export default {"tooltip":"BP-z","arrow":"CP-z"};